import { createContext } from "react";

/**
 * Tailwind classes that `<Text>` merges in from an enclosing styling scope (`<Button>`,
 * `<Badge>`, `<Select>`, `<Popover>`, …), or `undefined` when there is no such scope.
 *
 * The default is `undefined`, NOT a `defaultError(...)` guard. Unlike the repo's other
 * contexts, "no provider" is a legitimate, common state here: a bare `<Text>` rendered
 * outside any styling scope is ordinary usage and must simply contribute no extra classes.
 * A throwing default made every such render fail — `use(TextClassContext)` returns the
 * error Proxy and `<Text>` passes it straight into `cn(...)`, whose first property access
 * throws "TextClassContext can only be accessed within a <TextClassContextProvider>".
 * The app only avoided it because `RootNavigationTheme` wraps the tree in an explicit
 * `<TextClassContext value={undefined}>`, which exists solely to neutralize that default;
 * anything rendered outside that wrapper (every component test, and any future entrypoint
 * that doesn't mount the full root layout) blew up. `defaultError` is right for contexts
 * carrying a required dependency — it is wrong for an optional styling scope whose own
 * type is `string | undefined`.
 */
export const TextClassContext = createContext<string | undefined>(undefined);
